export default __webpack_public_path__ + "static/media/user-13.dd401b44.jpg";